import api from './api'

export interface LeadNote {
    id: number
    lead_id: number | null
    chat_id: number | null
    text: string
    remind_at: string | null
    remind_sent: boolean
    created_at: string
    author_id: number | null
    author_name: string | null
    can_delete: boolean
    // Приходит только при создании: почему заметка не ушла в CRM Wiseway.
    crm_warning?: string | null
}

export interface LeadNotePayload {
    lead_id?: number | null
    chat_id?: number | null
    text: string
    remind_at?: string | null
}

// Заметки общие: их видит каждый, кто видит лида. Сервер сам решает, кому
// разрешено удалять запись, и возвращает это в поле can_delete.
export const leadNotesApi = {
    getNotes: (params: { leadId?: number | null; chatId?: number | null }) =>
        api.get<LeadNote[]>('/lead-notes', {
            params: {
                ...(params.leadId ? { lead_id: params.leadId } : {}),
                ...(params.chatId ? { chat_id: params.chatId } : {}),
            },
        }),

    createNote: (data: LeadNotePayload) => api.post<LeadNote>('/lead-notes', data),

    // Меняется только напоминание: текст заметки после сохранения неизменяем.
    updateNote: (noteId: number, data: { remind_at?: string | null; clear_remind?: boolean }) =>
        api.put<LeadNote>(`/lead-notes/${noteId}`, data),

    deleteNote: (noteId: number) => api.delete(`/lead-notes/${noteId}`),
}
